import { useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import { forgotPassword } from "../../lib/api";

/** Useful landing page for signed-in accounts without board access. */
export function AccountPage() {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const canRead = user?.permissions.includes("*") || user?.permissions.includes("jobs.read");
  async function reset(): Promise<void> {
    if (!user || busy) return;
    setBusy(true); setError(""); setMessage("");
    try { await forgotPassword(user.email); setMessage("Password reset requested. Check your email for the next step."); }
    catch (failure) { setError(failure instanceof Error ? failure.message : "Could not request a password reset."); }
    finally { setBusy(false); }
  }
  return <main className="page"><div className="page-head"><div className="page-headline"><h1 className="page-title">Your account</h1><p className="page-lede">{user?.displayName}</p></div></div>
    <p>{user?.email}</p>
    {!canRead && <p className="alert">Your account has no job access. Contact an administrator if you need access to jobs.</p>}
    <p>Contact an administrator to update your account details.</p>
    <button type="button" className="btn btn--secondary btn--36" disabled={busy} onClick={() => void reset()}>{busy ? "Requesting…" : "Request password reset"}</button>
    {message && <p role="status" className="alert alert--success">{message}</p>}{error && <p role="alert" className="alert alert--error">{error}</p>}
  </main>;
}
